import type { CheckoutSkiAncillaryServiceOption } from '../../../domain/types'
import { getPriceForParticipant } from '../priceHelpers'

export function getDaysRangeFormatted(start: string, end: string, locale: string) {
  const newStartDate = new Date(start)
  const newEndDate = new Date(end)
  const startDayName = newStartDate.toLocaleString(locale, { weekday: 'long' })
  const newEndDayName = newEndDate.toLocaleString(locale, { weekday: 'long' })

  return { startDay: startDayName, endDay: newEndDayName }
}

export function getPriceDifferenceAndPriceSymbol(selectedValue: string | null, price: number, options: Record<string, CheckoutSkiAncillaryServiceOption>, participantId?: string) {
  const selectedOption = selectedValue ? options[selectedValue] : undefined
  let priceDifference = price

  if (selectedValue && selectedOption)
    priceDifference = price - getPriceForParticipant(selectedOption, participantId)

  let priceSymbol = ''

  if (priceDifference > 0) {
    priceSymbol = '+'
  }
  if (priceDifference < 0) {
    priceSymbol = '-'
  }
  return { priceDifference, priceSymbol }
}

// Always show the minus sign; the plus sign relies on hasIncludedOption using data
// Note: some sites as ski material for france returns included = false even when it should be true,
// hence ensuring that minus sign is always shown when appropriate
export function shouldShowSignSelectedOption(participantPrice: number, hasIncludedOption: boolean): boolean {
  if (participantPrice < 0)
    return true

  return participantPrice !== 0 && hasIncludedOption
}
